import React from 'react';


function ConflictOfInterestPolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Conflict of Interest Policy</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Policy Purpose</h2>
            <p className="leading-relaxed">
              To preserve the integrity of AASC standards, this policy establishes strict guidelines for identifying and managing conflicts of interest. It ensures that standards are defined based on technical merit rather than commercial benefit.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Definition of Conflict</h2>
            <p className="leading-relaxed">
              A conflict of interest exists when a Council member, staff member, or committee participant has a financial, professional, or personal interest that could impair their ability to act impartially in the definition or enforcement of standards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Disclosure Requirements</h2>
            <ol className="list-decimal pl-5 space-y-2 mt-2">
              <li><strong>Annual Disclosure:</strong> All key personnel must file an annual disclosure statement listing relevant financial interests.</li>
              <li><strong>Event-Based Disclosure:</strong> Participants must disclose specific conflicts prior to voting on related standards or engaging in review processes.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Recusal Procedures</h2>
            <p className="leading-relaxed">
              Individuals with a disclosed conflict regarding a specific vendor, technology, or operator must recuse themselves from all decision-making authority related to that subject. Recused members may provide factual information but may not vote.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">5. Vendor Neutrality</h2>
            <p className="leading-relaxed">
              The Council prohibits the acceptance of compensation from AI software vendors in exchange for preferential treatment in standards definitions. All standards must remain vendor-agnostic.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default ConflictOfInterestPolicy;